import type { ContentType } from '@/lib/types'
import Multiselect from '@cloudscape-design/components/multiselect'
import type { MultiselectProps } from '@cloudscape-design/components/multiselect'

export interface ContentTypeGridProps {
  selected: ContentType[]
  onChange: (types: ContentType[]) => void
  disabled?: boolean
}

const CHANNEL_OPTIONS: MultiselectProps.Option[] = [
  { value: 'facebook_post', label: 'Facebook' },
  { value: 'twitter_post', label: 'Twitter / X' },
  { value: 'linkedin_post', label: 'LinkedIn' },
  { value: 'gbp_post', label: 'Google Business Profile' },
]

export default function ContentTypeGrid({ selected, onChange, disabled = false }: ContentTypeGridProps) {
  return (
    <Multiselect
      selectedOptions={selected.map(type => ({
        value: type,
        label: CHANNEL_OPTIONS.find(opt => opt.value === type)?.label || type,
      }))}
      onChange={({ detail }) => onChange(detail.selectedOptions.map(opt => opt.value as ContentType))}
      options={CHANNEL_OPTIONS}
      placeholder="Select one or more channels…"
      disabled={disabled}
    />
  )
}
